"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigPrinter = exports.ChainFormatter = void 0;
var ChainFormatter = {
  Programmatic: 0,
  Config: 1
};
exports.ChainFormatter = ChainFormatter;
var Formatter = {
  title: function title(type, callerName, filepath) {
    var title = "";

    if (type === ChainFormatter.Programmatic) {
      title = "programmatic options";

      if (callerName) {
        title += " from " + callerName;
      }
    } else {
      title = "config " + filepath;
    }

    return title;
  },
  loc: function loc(index, envName) {
    var loc = "";

    if (index != null) {
      loc += ".overrides[".concat(index, "]");
    }

    if (envName != null) {
      loc += ".env[\"".concat(envName, "\"]");
    }

    return loc;
  },
  optionsAndDescriptors: function optionsAndDescriptors(opt) {
    var content = Object.assign({}, opt.options);
    delete content.overrides;
    delete content.env;

    var pluginDescriptors = _toConsumableArray(opt.plugins());

    if (pluginDescriptors.length) {
      content.plugins = pluginDescriptors.map(function (d) {
        return descriptorToConfig(d);
      });
    }

    var presetDescriptors = _toConsumableArray(opt.presets());

    if (presetDescriptors.length) {
      content.presets = _toConsumableArray(presetDescriptors).map(function (d) {
        return descriptorToConfig(d);
      });
    }

    return JSON.stringify(content, undefined, 2);
  }
};

function descriptorToConfig(d) {
  var _d$file;

  var name = (_d$file = d.file) == null ? void 0 : _d$file.request;

  if (name == null) {
    if (typeof d.value === "object") {
      name = d.value;
    } else if (typeof d.value === "function") {
      name = "[Function: ".concat(d.value.toString().substr(0, 50), " ... ]");
    }
  }

  if (name == null) {
    name = "[Unknown]";
  }

  if (d.options === undefined) {
    return name;
  } else if (d.name == null) {
    return [name, d.options];
  } else {
    return [name, d.options, d.name];
  }
}

var ConfigPrinter = /*#__PURE__*/function () {
  function ConfigPrinter() {
    _classCallCheck(this, ConfigPrinter);

    this._stack = [];
  }

  _createClass(ConfigPrinter, [{
    key: "configure",
    value: function configure(enabled, type, _ref) {
      var _this = this;

      var callerName = _ref.callerName,
          filepath = _ref.filepath;
      if (!enabled) return function () {};
      return function (content, index, envName) {
        _this._stack.push({
          type: type,
          callerName: callerName,
          filepath: filepath,
          content: content,
          index: index,
          envName: envName
        });
      };
    }
  }, {
    key: "output",
    value: function output() {
      if (this._stack.length === 0) return "";
      return this._stack.map(function (s) {
        return ConfigPrinter.format(s);
      }).join("\n\n");
    }
  }], [{
    key: "format",
    value: function format(config) {
      var title = Formatter.title(config.type, config.callerName, config.filepath);
      var loc = Formatter.loc(config.index, config.envName);
      if (loc) title += " ".concat(loc);
      var content = Formatter.optionsAndDescriptors(config.content);
      return "".concat(title, "\n").concat(content);
    }
  }]);

  return ConfigPrinter;
}();

exports.ConfigPrinter = ConfigPrinter;